const navTabsSelection = () => {
    const navTabsLinks = document.querySelectorAll('.nav-tabs a');

    if (navTabsLinks.length < 1) {
        return;
    }

    const variationLinks = document.querySelectorAll('.configurationsType a');
    const tabActiveParam = 'tab_active';
    const url = new URL(location.href);
    const tabActive = url.searchParams.get(tabActiveParam);
    const stickyHeaderTabs = document.querySelectorAll('.stickyHeaderPrice');

    const updateLinks = (tabActive) => {
        url.searchParams.set(tabActiveParam, tabActive);
        history.pushState({}, null, url.href);

        if (variationLinks.length) {
            variationLinks.forEach((variationLink) => {
                const variationUrl = new URL(variationLink.href);
                variationUrl.searchParams.set(tabActiveParam, tabActive);
                variationLink.href = variationUrl.href;
            });
        }
    };

    const updateStickyHeaderPrices = (stickyHeaderPriceTabName) => {
        stickyHeaderTabs.forEach((stickyHeaderTab) => {
            stickyHeaderTab.classList.contains(stickyHeaderPriceTabName) ?
                stickyHeaderTab.classList.remove('hide') :
                stickyHeaderTab.classList.add('hide');
        });
    };

    navTabsLinks.forEach(navTabLink =>
        navTabLink.addEventListener('click', () => {
            const href = navTabLink.getAttribute('href');
            const rel = href.indexOf('#') === 0 ? href.replace('#', '') : null;
            if (rel) {
                updateLinks(rel);
            }
            const stickyHeaderPriceTabName = navTabLink.getAttribute('data-sticky-header-price-tab');
            if (stickyHeaderPriceTabName) {
                updateStickyHeaderPrices(stickyHeaderPriceTabName);
            }
        })
    );

    if (!$('.detailsHandset').length && tabActive) {
        [...navTabsLinks].find(navTabLink =>
            navTabLink.getAttribute('href') === `#${tabActive}`
        ).click();
    }
    $(document).on('click', '.navTanPresentation', function() {
        if ($(this).attr('data-ref-hidden') == 'Paym') {
            showHideHiddenTag('Paym', 'PaymUpgrade', 'Simfree');
        } else if ($(this).attr('data-ref-hidden') == 'PaymUpgrade') {
            showHideHiddenTag('PaymUpgrade', 'Paym', 'Simfree');
        } else {
            showHideHiddenTag('Simfree', 'Paym', 'PaymUpgrade');
        }
    });
};
function showHideHiddenTag(show, hideOne, hideTwo) {
    if ($('.hiddenDealTag' + show).length && $('.hiddenDealTag' + show).hasClass('hide')) {
        $('.hiddenDealTag' + show).removeClass('hide');
    }
    if ($('.hiddenDealTag' + hideOne).length && !$('.hiddenDealTag' + hideOne).hasClass('hide')) {
        $('.hiddenDealTag' + hideOne).addClass('hide');
    }
    if ($('.hiddenDealTag' + hideTwo).length && !$('.hiddenDealTag' + hideTwo).hasClass('hide')) {
        $('.hiddenDealTag' + hideTwo).addClass('hide');
    }
}
export default navTabsSelection;
